module.exports = __webpack_public_path__ + "static/img/hair_04.384e58e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_04.png
// module id = yIIP
// module chunks = 0